export const YoutubeIcon = ({ fill = "#232734" }: { fill?: string }) => {
  return (
    <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M18.9092 4.04112C19.2198 4.35167 19.4436 4.73817 19.5583 5.16211V5.16219C20.2188 7.82109 20.0662 12.0205 19.5711 14.782C19.4564 15.206 19.2326 15.5925 18.922 15.9031C18.6115 16.2136 18.225 16.4374 17.801 16.5521C16.2491 16.9754 10.0026 16.9754 10.0026 16.9754C10.0026 16.9754 3.75603 16.9754 2.204 16.5521C1.78007 16.4373 1.39358 16.2136 1.08303 15.903C0.772488 15.5925 0.548716 15.206 0.433999 14.782C-0.230454 12.1347 -0.0483445 7.93266 0.421109 5.175C0.535813 4.75104 0.759581 4.36453 1.07012 4.05396C1.38067 3.74338 1.76717 3.51958 2.19111 3.40484C3.74314 2.98156 9.98983 2.96875 9.98983 2.96875C9.98983 2.96875 16.2362 2.96875 17.7883 3.39203C18.2122 3.50677 18.5987 3.73056 18.9092 4.04112ZM13.1836 9.972L8.00171 12.9734V6.97062L13.1836 9.972Z"
        fill={fill}
        fillRule="evenodd"
      />
    </svg>
  )
}
